import { render, staticRenderFns } from "./RegisterSuccess.vue?vue&type=template&id=217d875a"
import script from "./RegisterSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterSuccess.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports